import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Add error handler to catch any initialization errors
const rootElement = document.getElementById("root")

// Create a basic error handler for React initialization
window.addEventListener('error', (event) => {
  if (rootElement) {
    // If there's a critical error, provide a minimal emergency login UI
    rootElement.innerHTML = `
      <div style="font-family: sans-serif; height: 100vh; display: flex; align-items: center; justify-content: center; flex-direction: column; background-color: #f3f4f6;">
        <div style="max-width: 500px; padding: 2rem; background-color: white; border-radius: 8px; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
          <h2 style="margin-top: 0; color: #dc2626;">Application Error</h2>
          <p>We're having trouble loading the application. This might be due to a network issue or server problem.</p>
          <p style="margin-bottom: 1.5rem; font-size: 0.875rem; color: #6b7280;">${event.message || 'Unknown error'}</p>
          <button 
            onclick="window.location.href='/direct-login'"
            style="padding: 0.5rem 1rem; background-color: #3b82f6; color: white; border: none; border-radius: 4px; cursor: pointer;"
          >
            Go to Login Page
          </button>
          <button 
            onclick="window.location.reload()"
            style="margin-left: 0.5rem; padding: 0.5rem 1rem; background-color: #4b5563; color: white; border: none; border-radius: 4px; cursor: pointer;"
          >
            Refresh Page
          </button>
        </div>
      </div>
    `;
  }
  console.error('Critical error in application:', event.error || event.message);
});

// Render the app
try {
  if (rootElement) {
    const root = createRoot(rootElement)
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    )
  } else {
    console.error('Root element not found');
  }
} catch (error) {
  console.error('Failed to render the app:', error);
  // The error handler above will catch this
}
